export const formMenuData = translations => [
  {
    country: translations.unitedStates || 'United States',
    teams: [
      {
        name: 'Depot',
        forms: [
          {
            name: 'Bench Repair',
            componentKey: 'BenchRepairForm',
          },
          {
            name: 'RLT Worklog',
            componentKey: 'RltWorklogForm',
          },
        ],
      },
      {
        name: 'FST',
        forms: [
          {
            name: translations.incorrectCase || 'Incorrect Case',
            componentKey: 'IncorrectCaseForm',
          },
          {
            name: translations.overtime || 'Overtime',
            componentKey: 'FSTOvertimeForm',
          },
        ],
      },
      {
        name: 'NRC',
        forms: [
          {
            name: 'Antilles Credit Log',
            componentKey: 'AntillesCreditLogForm',
          },
          {
            name: 'California PTL',
            componentKey: 'CaliforniaPTLForm',
          },
          {
            name: 'Consumable Supply',
            componentKey: 'ConsumableSupplyForm',
          },
          // PENDING WORK ON THIS FORM, DO NOT DELETE
          // {
          //   name: 'Consumable Supply Notificiation',
          //   componentKey: 'ConsumableSupplyNotificationForm',
          // },
          {
            name: 'Dispatch Status Change Request',
            componentKey: 'DispatchStatusChangeRequestForm',
          },
          {
            name: 'Forward-To-Site',
            componentKey: 'ForwardToSiteForm',
          },
          {
            name: 'GNIE Update Request',
            componentKey: 'GNIEUpdateRequestForm',
          },
          {
            name: 'Michigan Incident Log',
            componentKey: 'MichiganIncidentLogForm',
          },
          {
            name: 'New Jersey Function Suppressed',
            componentKey: 'NJSuppressedForm',
          },
          {
            name: 'New York AM Log',
            componentKey: 'NYAMLogForm',
          },
          {
            name: 'New York Key Request',
            componentKey: 'NYKeyRequestForm',
          },
          {
            name: 'NRC Downtime',
            componentKey: 'NRCDowntimeForm',
          },
          {
            name: 'Retailer Information Change',
            componentKey: 'RetailerInfoChangeForm',
          },
          {
            name: 'Stolen & Missing Instant Ticket Report',
            componentKey: 'StolenAndMissingInstantTicketForm',
          },
          {
            name: 'Texas Scratch Ticket Order Form',
            componentKey: 'TexasScratchTicketForm',
          },
          {
            name: 'Washington Retailer Training Request',
            componentKey: 'WARetailerTrainingRequestForm',
          },
        ],
      },
    ],
  },
];
